import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7dcffe37"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "extra-metadata" }
const _hoisted_2 = { class: "extra-metadata-icon btn btn-icon btn-sm btn-warning position-relative me-3" }
const _hoisted_3 = { class: "mas" }
const _hoisted_4 = {
  key: 0,
  class: "extra-metadata-badge badge rounded-pill"
}
const _hoisted_5 = { class: "fw-700 me-3" }
const _hoisted_6 = { class: "extra-metadata-summary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseAccordionHeader = _resolveComponent("BaseAccordionHeader")!
  const _component_BaseAccordionCollapse = _resolveComponent("BaseAccordionCollapse")!
  const _component_BaseAccordionItem = _resolveComponent("BaseAccordionItem")!
  const _component_BaseAccordion = _resolveComponent("BaseAccordion")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_BaseAccordion, { id: _ctx.accordionId }, {
      default: _withCtx(() => [
        _createVNode(_component_BaseAccordionItem, null, {
          default: _withCtx(() => [
            _createVNode(_component_BaseAccordionHeader, {
              id: _ctx.headerId,
              target: _ctx.collapseId,
              isOpen: _ctx.isOpen
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_2, [
                  _createElementVNode("i", _hoisted_3, _toDisplayString(_ctx.isOpen ? 'discover_tune' : 'instant_mix'), 1),
                  (_ctx.activeLabels.length)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.activeLabels.length), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('cms.extraMetadata')), 1),
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.summary), 1)
              ]),
              _: 1
            }, 8, ["id", "target", "isOpen"]),
            _createVNode(_component_BaseAccordionCollapse, {
              id: _ctx.collapseId,
              labelId: _ctx.headerId,
              parentId: _ctx.accordionId,
              isOpen: _ctx.isOpen,
              isAlwaysOpen: ""
            }, {
              default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "default", {}, undefined, true)
              ]),
              _: 3
            }, 8, ["id", "labelId", "parentId", "isOpen"])
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["id"])
  ]))
}